const _ = require('lodash')

function getBaseLoginAppURL() {
  const clientAccountLoginAppPath = process.env.NODE_ENV === 'production'
    ? '/login/'
    : '/clientaccount/login/'

  const clientAccountAppLocation = _.get(process.env, 'VUE_APP_CLIENT_ACCOUNT_LOGIN_APP_LOCATION', null)

  if (clientAccountAppLocation === null) {
    return clientAccountLoginAppPath
  }

  return `${clientAccountAppLocation}${clientAccountLoginAppPath}`
}

function getBaseClientAccountAppURL() {
  return process.env.NODE_ENV === 'production'
    ? '/'
    : '/clientaccount/'
}

function getBaseClientAccountApiURL() {
  return process.env.NODE_ENV === 'production'
    ? '/api/'
    : '/clientaccount/api/'
}

module.exports = {
  getBaseLoginAppURL: getBaseLoginAppURL,
  getBaseClientAccountAppURL: getBaseClientAccountAppURL,
  getBaseClientAccountApiURL: getBaseClientAccountApiURL
}